/**
 * RequiredAsterisk — inline red asterisk for required form field labels.
 * RTL-safe: ms-1 adds margin-inline-start so the gap between label text and
 * asterisk is correct in both LTR and RTL reading directions.
 * @layer-1 — use via FormField required prop or directly in label JSX.
 */
export function RequiredAsterisk() {
  return (
    <span
      aria-hidden="true"
      className="ms-1"
      style={{ color: "var(--destructive)" }}
    >
      *
    </span>
  );
}
